// extracted by mini-css-extract-plugin
export default {"cls1":"I9Ijt36ZNKsFsnIYj2MO","cls2":"ip7DQwbR8LBr1BU5VEPA I9Ijt36ZNKsFsnIYj2MO"};